module.exports = __webpack_public_path__ + "static/media/home2_portrait.7099f883.png";